import React from 'react'
import {withRouter} from "react-router-dom"
import {connect} from 'react-redux'
import {getAccessToken} from '../reducers/asciidoc/Auth/action'


class AuthCode extends React.Component {

    UNSAFE_componentWillMount() {
        const { getAccessToken } = this.props;
        const code = getQueryVariable('code');
        if(code) {
            getAccessToken(code);
        } else {
            this.props.history.push('/'+this.props.location.search);
        }
    }

    render() {
        const { connected } = this.props;

        if(connected === true) {
            this.props.history.push('/')
        } else {
            //this.props.history.push('/401')
        }

        return '';
    }
}

function mapStateToProps(state) {
    return {connected : state.AccessToken.connected }
}

function getQueryVariable(variable)
{
    let query = window.location.search;
    let vars = query.replace('?', '').split("&");
    for (let i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        if(pair[0] === variable){return pair[1];}
    }
    return false;
}

const mapDispatchToProps = {
    getAccessToken
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthCode))